<script setup lang="ts">
import type { MenuTheme } from '../types';

defineProps<{
  theme: MenuTheme
}>();
</script>

<template>
  <ul :class="theme.class">
    <slot v-bind="{ theme }" />
  </ul>
</template>
